export function getNodes<T>(
  data:
    | { edges?: ({ node?: T | null | undefined } | null)[] | null | undefined }
    | null
    | undefined,
  filter?: (node: T) => boolean
) {
  return (
    data?.edges?.reduce<T[]>((acc, cur) => {
      if (!cur?.node) return acc
      if (!!filter && !filter(cur.node)) return acc

      acc.push(cur.node)
      return acc
    }, []) ?? []
  )
}

export function dateFormat(date: Date) {
  return date.toISOString().split('T')[0] ?? 'Invalid Date'
}

export function getPageInfo(
  data:
    | { pageInfo: { hasNextPage: boolean; endCursor?: string | null } }
    | undefined
) {
  return {
    hasNextPage: data?.pageInfo.hasNextPage ?? false,
    cursor: data?.pageInfo.endCursor ?? null,
  }
}
